export const BASE_URL = "https://prod.api.morbibazaar.com/api/v1/";

export const API_URL = {
  CATEGORY_LIST: `${BASE_URL}category`,
  CATEGORY_GET: `${BASE_URL}category/show`,
  CATEGORY_SAVE: `${BASE_URL}category/store`,
  CATEGORY_UPDATE: `${BASE_URL}category/update`,
  CATEGORY_DELETE: `${BASE_URL}category/delete`,

  COMPANY_LIST: `${BASE_URL}company`,
  COMPANY_GET: `${BASE_URL}company/show`,
  COMPANY_SAVE: `${BASE_URL}company/store`,
  COMPANY_UPDATE: `${BASE_URL}company/update`,
  COMPANY_DELETE: `${BASE_URL}company/delete`,

  GRADE_LIST: `${BASE_URL}grade`,
  GRADE_GET: `${BASE_URL}grade/show`,
  GRADE_SAVE: `${BASE_URL}grade/store`,
  GRADE_UPDATE: `${BASE_URL}grade/update`,
  GRADE_DELETE: `${BASE_URL}grade/delete`,

  CITY_LIST: `${BASE_URL}city`,
  CITY_GET: `${BASE_URL}city/show`,
  CITY_SAVE: `${BASE_URL}city/store`,
  CITY_UPDATE: `${BASE_URL}city/update`,
  CITY_DELETE: `${BASE_URL}city/delete`,

  COUNTRY_LIST: `${BASE_URL}country`,
  COUNTRY_GET: `${BASE_URL}country/show`,
  COUNTRY_SAVE: `${BASE_URL}country/store`,
  COUNTRY_UPDATE: `${BASE_URL}country/update`,
  COUNTRY_DELETE: `${BASE_URL}country/delete`,

  STATE_LIST: `${BASE_URL}state`,
  STATE_GET: `${BASE_URL}state/show`,
  STATE_SAVE: `${BASE_URL}state/store`,
  STATE_UPDATE: `${BASE_URL}state/update`,
  STATE_DELETE: `${BASE_URL}state/delete`,

  PARTY_LIST: `${BASE_URL}party`,
  PARTY_GET: `${BASE_URL}party/show`,
  PARTY_SAVE: `${BASE_URL}party/store`,
  PARTY_UPDATE: `${BASE_URL}party/update`,
  PARTY_DELETE: `${BASE_URL}party/delete`,
  PARTY_UPDATE_STATUS: `${BASE_URL}party/update-status`,

  SIZE_LIST: `${BASE_URL}size`,
  SIZE_GET: `${BASE_URL}size/show`,
  SIZE_SAVE: `${BASE_URL}size/store`,
  SIZE_UPDATE: `${BASE_URL}size/update`,
  SIZE_DELETE: `${BASE_URL}size/delete`,

  POST_LIST: `${BASE_URL}posts`,
  POST_GET: `${BASE_URL}posts/show`,
  POST_SAVE: `${BASE_URL}posts/store`,
  POST_UPDATE: `${BASE_URL}posts/update`,
  POST_DELETE: `${BASE_URL}posts/delete`,

  SERIES_LIST: `${BASE_URL}series`,
  SERIES_GET: `${BASE_URL}series/show`,
  SERIES_SAVE: `${BASE_URL}series/store`,
  SERIES_UPDATE: `${BASE_URL}series/update`,
  SERIES_DELETE: `${BASE_URL}series/delete`,
  SERIES_IMAGES: `${BASE_URL}series/images`,
  SERIES_SAVE_IMAGE: `${BASE_URL}series/save-image`,
  SERIES_DELETE_IMAGE: `${BASE_URL}series/delete-image`,
  SERIES_PAGE_NUMBER: `${BASE_URL}series/order-image`,

  PRODUCT_LIST: `${BASE_URL}product`,
  PRODUCT_GET: `${BASE_URL}product/show`,
  PRODUCT_SAVE: `${BASE_URL}product/store`,
  PRODUCT_UPDATE: `${BASE_URL}product/update`,
  PRODUCT_DELETE: `${BASE_URL}product/delete`,
  PRODUCT_WITH_SUB_LIST: `${BASE_URL}product/lists`,
  PRODUCT_ONLY_LIST: `${BASE_URL}product/only`,
  PRODUCT_HAS_SUB_LIST: `${BASE_URL}product/has-sub-product`,

  SAVE_USER: `${BASE_URL}save-user`,
  SETTING_PASSWORD: `${BASE_URL}password-update`,
  LOGIN_URL: `${BASE_URL}login`,
  STATES_LIST: `${BASE_URL}states`,
  LOGIN_USER: `${BASE_URL}me`,

  INVOICE_LIST: `${BASE_URL}sales`,
  INVOICE_GET: `${BASE_URL}sales/show`,
  INVOICE_SAVE: `${BASE_URL}sales/store`,
  INVOICE_UPDATE: `${BASE_URL}sales/update`,
  INVOICE_DELETE: `${BASE_URL}sales/delete`,
  INVOICE_STATUS_UPDATE: `${BASE_URL}sales/status-update`,

  NOTIFICATION: `${BASE_URL}send-notification`,
};

// File size limits (in MB)
export const MAX_post_image_SIZE = 5; // 5MB for images
export const MAX_post_video_SIZE = 50; // 50MB for videos
